<template>
  <v-card
    v-bind:class="{ archived: esignature.archived, hidden: (!viewArchived && esignature.archived) }"
    style="margin-bottom:20px;"
  >
    <FormTemplateFieldSelector
      :templateID="$route.params.id"
      v-if="!loading && fieldSelecting"
      @select="fieldSelecting = false;editsignature.conditional_question_id = arguments[0].question_id; editsignature.conditional_fieldtype_id = arguments[0].fieldtype_id"
      @cancel="fieldSelecting = false"
    />
    <v-toolbar
      dense
      flat
      style="position:relative;"
    >
        <a
          roll="button"
          class="handle"
          style="float:left;"
        >
          <v-icon small left>drag_handle</v-icon>
        </a>
        <v-icon>
          mdi-signature
        </v-icon>
        &nbsp;&nbsp;
        <b style="margin-right: 50px;">Signature Field</b>
        <div v-if="!editing">
          <v-chip 
            outline
            color="grey"
            small
            v-if="conditional_part"  
          >
            Conditional
          </v-chip>
          <v-chip 
            outline
            color="grey"
            small
            v-if="esignature.pdf_only"  
          >
            PDF Only
          </v-chip>
        </div>
        <ArchiveButton
          style="float:right;position:absolute;right:45px;top:12px;"
          :archived="esignature.archived"
          @restore="restore()"
          @archive="archive()"
        />
        <a
          roll="button"
          class="question-edit-button"
          style="float:right;position:absolute;right:15px;top:12px;"
          @click="editing=true"
        >
          <v-icon small color="blue">edit</v-icon>
        </a>
    </v-toolbar>
    <v-dialog
      v-model="editing"
      width="750"
    >
      <Preloader v-if="loading"/>
      <v-card>
        <v-toolbar
          flat
        >
          <v-icon>
            mdi-signature
          </v-icon>
          &nbsp;&nbsp;
          <b>Signature Field</b>
        </v-toolbar>
        <v-card-text>
          <v-alert
            :value="true"
            type="warning"
            :outline="true"
          >
            A signature is only collected when a client submits (when Sign on Submission is enabled) and when the status is changed to "Request Signature". Once a signature is requested, no changes should be made to the document as they will not be reflected in the signed document.
          </v-alert>
          <v-form>
            <br />
            <span>&nbsp;&nbsp;&nbsp;<b>Text </b>to display for signature field.&nbsp;&nbsp;&nbsp;<small><i>This is often a declaration or acknowledgement.</i></small></span>
            <br />
            <br />
            <Editor
              v-if="editing"
              ref="htmlEditor"
              :html="editsignature.text"
            />
            <v-layout 
              row 
              wrap 
            >
              <v-flex xs12 sm4>
                <v-checkbox
                  v-model="conditional_part"
                  label="Conditional Form Part"
                  persistent-hint
                  hint="Display part depending on answer to question"
                />
              </v-flex>
              <v-flex xs12 sm4>
                <v-checkbox
                  v-model="editsignature.pdf_only"
                  label="PDF Only"
                  persistent-hint
                  hint="Do not show on Web"
                />
              </v-flex>
            </v-layout>
            
            <v-layout 
              row 
              wrap 
              v-if="conditional_part"
            >
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="editsignature.conditional_question_id"
                  label="Question ID"
                  style="margin-right: 10px;"
                  disabled
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="editsignature.conditional_fieldtype_id"
                  label="Fieldtype ID"
                  style="margin-right: 10px;"
                  disabled
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="editsignature.conditional_value"
                  label="Conditional Value"
                  style="margin-right: 10px;"
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox
                  v-model="editsignature.conditional_apply_pdf"
                  label="Apply to PDF"
                  persistent-hint
                  hint="Hide from PDF if part fails condition"
                />
              </v-flex>
              <v-flex sm12>
                <v-btn
                  dense
                  @click="fieldSelecting = true"
                >
                  Select A Field
                </v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="editing"
            small
            @click="editing=false"
          >
            Cancel
          </v-btn>
          <v-btn
            v-if="editing"
            color="blue"
            dark
            small
            @click="save"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import Preloader from '@/components/global/Preloader'
import ArchiveButton from './ArchiveButton'
import Editor from '@/components/admin/Editor'
import FormTemplateFieldSelector from '../FormTemplateFieldSelector.vue'

export default {
  name: 'FormTemplateEsignature',
  props: [ 'partId', 'newPart' ],
  components: {
    Preloader,
    ArchiveButton,
    Editor,
    FormTemplateFieldSelector
  },
  data () {
    return {
      editsignature: {},
      editing: false,
      loading: false,
      conditional_part: false,
      fieldSelecting: false
    }
  },
  computed: {
    ...mapGetters('formtemplate', [
      'partById',
      'fieldTypeById'
    ]),
    ...mapState('formtemplate', [
      'viewArchived',
      'viewIdentifiers'
    ]),
    esignature () {
      return this.partById(this.partId) || this.newPart
    }
  },
  created () {
    this.editing = !(this.esignature.id)
    this.conditional_part = (this.esignature.conditional_question_id)
    this.loading = false
  },
  watch: {
    editing (val) {
      if (val) {
        this.editsignature = JSON.parse(JSON.stringify(this.esignature))
      } else {
        this.$emit('cancel')
      }
    }
  },
  methods: {
    ...mapActions('formtemplate', [
      'saveEsignature'
    ]),
    save () {
      this.loading = true
      this.saveHTML()
      if(!this.conditional_part){
        this.editsignature.conditional_question_id = null
        this.editsignature.conditional_fieldtype_id = null
        this.editsignature.conditional_apply_pdf = false
        this.editsignature.conditional_value = ""
      }
      this.saveEsignature(this.editsignature)
      .then(signature => {
        this.editing = false
        this.$emit('save', signature)
        this.loading = false
      })
    },
    archive () {
      this.loading = true
      this.esignature.archived = true
      this.saveEsignature(this.esignature)
      .then(signature => {
        this.$emit('save', signature)
        this.loading = false
      })
    },
    restore () {
      this.loading = true
      this.esignature.archived = false
      this.saveEsignature(this.esignature)
      .then(signature => {
        this.$emit('save', signature)
        this.loading = false
      })
    },
    saveHTML () {
      this.editsignature.text = this.$refs.htmlEditor.getHTML()
    }
  }
}
</script>

<style scoped>
.question-edit-button {
  margin-left: 10px;
}

.inlineLimiter >>> :first-child {
  display:inline;
}

.editor__content .ProseMirror {
  min-height: 250px;
}
</style>
